module.exports = __webpack_public_path__ + "img/train-station-min.8470fef0.jpg";